export default __webpack_public_path__ + "static/media/trapezoid-reversed.6092e412.webp";